/* 2026-10-12 (Claude), shipped on Joel's "ship". Joel: "can we move through gallery in these cards?".
   Runtime for the kit card photo gallery (.kc2g in snippets/product-grid-item.liquid, styles at the end of
   assets/_product-card.css). Swiping is native scroll-snap; this file adds:
   - the diamond dots and the desktop arrows (dim at the ends),
   - mouse drag on desktop, with the click after a drag swallowed so a drag never opens the kit
     (a plain tap or click still does, because the track sits inside the card's link),
   - lazy loading: photo 2 loads when the card nears the screen, the rest on the first touch,
     hover, arrow or swipe, so a card nobody touches costs one extra image,
   - the hover video (assets/aoam-kc2-video.js) only plays while photo 1 is showing.
   One copy per page however many cards emit the tag. Delete this file and its script tag to roll back;
   the photos still swipe without it. */
(function () {
  if (window.__aoamKc2Gallery) return;
  window.__aoamKc2Gallery = true;

  function hydrate(img) {
    if (!img || !img.hasAttribute('data-src')) return;
    var ss = img.getAttribute('data-srcset');
    if (ss) img.setAttribute('srcset', ss);
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      var s = en.target.querySelectorAll('.kc2g__slide img');
      hydrate(s[1]);
    });
  }, { rootMargin: '300px 0px' }) : null;

  function setup(g) {
    if (g._kc2g) return;
    g._kc2g = true;
    var track = g.querySelector('.kc2g__track');
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll('.kc2g__slide'));
    var n = slides.length;
    if (n < 2) return;
    var card = g.closest('.grid-item__content') || g.parentNode;
    var ctl = card.querySelector('.kc2g__ctl');
    var dots = ctl ? [].slice.call(ctl.querySelectorAll('.kc2g__dot')) : [];
    var prev = ctl && ctl.querySelector('.kc2g__arw--prev');
    var next = ctl && ctl.querySelector('.kc2g__arw--next');
    var wrap = g.closest('.grid-product__image-wrap');
    var idx = 0, all = false, raf = 0;

    function w() { return track.clientWidth || 1; }
    function loadAll() {
      if (all) return;
      all = true;
      slides.forEach(function (s) { hydrate(s.querySelector('img')); });
    }
    function paint() {
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === idx); });
      if (prev) prev.setAttribute('aria-disabled', idx === 0 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', idx === n - 1 ? 'true' : 'false');
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === idx ? 'false' : 'true'); });
      /* Hover video: aoam-kc2-video.js skips a wrap marked _kc2Dead, so the clip stays off
         while any photo but the first is showing, and comes back on photo 1. */
      if (wrap) {
        if (idx > 0) {
          wrap._kc2Dead = true;
          wrap._kc2Want = false;
          wrap.classList.remove('aoam-kc2--playing');
          if (wrap._kc2V) { try { wrap._kc2V.pause(); } catch (e) {} }
        } else if (!wrap._kc2Err) {
          wrap._kc2Dead = false;
        }
      }
    }
    function sync() {
      raf = 0;
      var i = Math.round(track.scrollLeft / w());
      i = Math.max(0, Math.min(n - 1, i));
      if (i !== idx) { idx = i; paint(); }
    }
    track.addEventListener('scroll', function () {
      loadAll();
      if (!raf) raf = requestAnimationFrame(sync);
    }, { passive: true });
    track.addEventListener('touchstart', loadAll, { passive: true });
    card.addEventListener('mouseenter', loadAll);

    function go(d, e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      loadAll();
      var t = Math.max(0, Math.min(n - 1, idx + d));
      if (t === idx) return;
      track.scrollTo({ left: t * w(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function (e) { go(-1, e); });
    if (next) next.addEventListener('click', function (e) { go(1, e); });
    /* 2026-11-02 (Claude) Joel: "these dots dont work". Tapping the dot pill jumps to the nearest dot's photo
       (the CSS gives the pill a bigger hit area). Delete this listener and the 2026-11-02 CSS block to roll back. */
    var row = ctl && ctl.querySelector('.kc2g__dots');
    if (row) row.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var b = 0, bd = Infinity;
      dots.forEach(function (d, k) { var r = d.getBoundingClientRect(), dd = Math.abs(r.left + r.width / 2 - e.clientX); if (dd < bd) { bd = dd; b = k; } });
      go(b - idx);
    });

    /* Mouse drag (desktop). Touch and trackpads use the native scroll. */
    var down = false, moved = false, sx = 0, sl = 0, start = 0;
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      loadAll();
      down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; start = Math.round(sl / w());
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('kc2g--drag'); }
      if (moved) { track.scrollLeft = sl - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function (e) {
      if (!down) return;
      down = false;
      if (!moved) return;
      var dx = e.clientX - sx;
      var t = Math.round((sl - dx) / w());
      if (t === start && Math.abs(dx) > 40) t = start + (dx < 0 ? 1 : -1);
      t = Math.max(0, Math.min(n - 1, t));
      track.scrollTo({ left: t * w(), behavior: 'smooth' });
      setTimeout(function () { track.classList.remove('kc2g--drag'); }, 450);
    });
    /* A drag ends in a click on the card link; swallow that one click only. */
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    if (io) io.observe(g); else hydrate(slides[1].querySelector('img'));
    paint();
  }

  function scan(root) {
    [].forEach.call((root || document).querySelectorAll('[data-kc2g]'), setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  /* Collection pages add cards by ajax (filters, load more): set those up too. */
  if ('MutationObserver' in window) {
    var mt = 0;
    new MutationObserver(function () {
      if (mt) return;
      mt = setTimeout(function () { mt = 0; scan(); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.aoamKc2Gallery = { scan: scan };
})();
